<div class="cards">
  @for (card of cards; track $index) {
  <td class="card-container">
    <app-small-card [card]="cards[$index]"> </app-small-card>
  </td>
  }
</div>
